import { manufacturersService } from "../_services";
const initialState = {
  all: [],
  selected: {
    manufacturer: null,
    model: null
  },
  error: {},
  loading: false,
  manufacturerToEdit: {},
  manufacturerToDelete: {},
  modelToEdit: {},
  modelToDelete: {},
  selectableOptions: {
    yes: true,
    no: false
  }
};
const state = Object.assign({}, initialState);
export const manufacturers = {
  namespaced: true,
  state: state,
  getters: {
    manufacturers: state => state.all,
    getManufacturerById: state => id => {
      return state.all.find(manufacturer => manufacturer.id === id);
    },
    availiableManufacturers: state =>
      state.all.filter(
        manufacturer =>
          manufacturer.models &&
          manufacturer.models.some(model => model.isSelectable == true)
      ),
    notAvailableManufacturers: state =>
      state.all.filter(manufacturer =>
        manufacturer.models.every(model => model.isSelectable == false)
      )
  },
  actions: {
    getAllManufacturers: ({ commit }, payload) => {
      commit("setLoading");
      manufacturersService.getAllManufacturers(payload).then(
        manufacturers => commit("getAllManufacturersSuccess", manufacturers),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    addManufacturer: ({ commit }, payload) => {
      manufacturersService.addManufacturer(payload).then(
        manufacturer => commit("addManufacturerSuccess", manufacturer),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    editManufacturer: ({ commit }, payload) => {
      manufacturersService.editManufacturer(payload).then(
        manufacturer => commit("editManufacturerSuccess", manufacturer),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    deleteManufacturer: ({ commit }, payload) => {
      manufacturersService.deleteManufacturer(payload).then(
        () => {
          commit("deleteManufacturerSuccess", payload);
        },
        error => {
          commit("alert/error", error, { root: true });
          window.scrollTo({ top: 0, behavior: "smooth" });
          commit("getAllFailure");
        }
      );
    },
    addModel: ({ commit }, payload) => {
      manufacturersService.addModel(payload).then(
        model => {
          commit("addModelSuccess", model);
          commit("setManufacturerSelectableState", payload.manufacturerId);
        },
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    editModel: ({ commit }, payload) => {
      manufacturersService.editModel(payload).then(
        model => {
          commit("editModelSuccess", model);
          commit("setManufacturerSelectableState", payload.manufacturerId);
        },
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    deleteModel: ({ commit }, payload) => {
      manufacturersService.deleteModel(payload).then(
        () => {
          commit("deleteModelSuccess", payload);
          commit("setManufacturerSelectableState", payload.manufacturerId);
        },
        error => {
          commit("alert/error", error, { root: true });
          window.scrollTo({ top: 0, behavior: "smooth" });
          commit("getAllFailure");
        }
      );
    }
  },
  mutations: {
    setLoading(state) {
      state.loading = true;
    },
    getAllManufacturersSuccess(state, manufacturers) {
      state.loading = false;
      state.all = manufacturers;
    },
    getAllFailure(state) {
      state.loading = false;
    },
    clearSelected(state) {
      state.selected.manufacturer = null;
      state.selected.model = null;
    },
    addManufacturerSuccess(state, manufacturer) {
      const newManufacturer = manufacturer;
      newManufacturer["isSelectable"] = false;
      newManufacturer["models"] = [];
      state.all.unshift(newManufacturer);
    },
    editManufacturerSuccess(state, manufacturer) {
      const item = state.all.find(item => item.id === manufacturer.id);
      item.name = manufacturer.name;
      Object.assign(state.manufacturerToEdit, initialState.manufacturerToEdit);
    },
    deleteManufacturerSuccess(state, manufacturer) {
      if (manufacturer) {
        const index = state.all.findIndex(item => item.id === manufacturer.id);
        if (index > -1) {
          state.all.splice(index, 1);
        }
      }

      Object.assign(
        state.manufacturerToDelete,
        initialState.manufacturerToDelete
      );
    },
    addModelSuccess(state, model) {
      state.all
        .find(manufacturer => manufacturer.id === model.manufacturerId)
        .models.unshift(model);
    },
    editModelSuccess(state, model) {
      const currentManufacturer = state.all.find(manufacturer => {
        return manufacturer.models.find(
          targetModel => targetModel.id === model.id
        );
      });
      const targetModel =
        currentManufacturer &&
        currentManufacturer.models.find(
          targetModel => targetModel.id === model.id
        );
      if (model.manufacturerId !== currentManufacturer.id) {
        currentManufacturer.models.splice(
          currentManufacturer.models.indexOf(targetModel),
          1
        );
        const newManufacturer = state.all.find(
          manufacturer => manufacturer.id === model.manufacturerId
        );
        newManufacturer.models.unshift(model);
        currentManufacturer.isSelectable = currentManufacturer.models.some(
          model => model.isSelectable == true
        );
      } else if (targetModel) {
        Object.assign(targetModel, model);
      }
      Object.assign(state.modelToEdit, initialState.modelToEdit);
    },
    deleteModelSuccess(state, model) {
      if (model) {
        const manufacturer = state.all.find(
          manufacturer => manufacturer.id === model.manufacturerId
        );

        const index =
          manufacturer &&
          manufacturer.models.findIndex(item => item.id === model.id);

        if (index > -1) {
          manufacturer.models.splice(index, 1);
        }
      }

      Object.assign(state.modelToDelete, initialState.modelToDelete);
    },
    setEditManufacturer(state, manufacturer) {
      Object.assign(state.manufacturerToEdit, manufacturer);
    },
    setDeleteManufacturer(state, manufacturer) {
      Object.assign(state.manufacturerToDelete, manufacturer);
    },
    setEditModel(state, model) {
      Object.assign(state.modelToEdit, model);
    },
    setDeleteModel(state, model) {
      Object.assign(state.modelToDelete, model);
    },
    setManufacturerSelectableState(state, manufacturerId) {
      const targetManufacturer = state.all.find(
        targetManufacturer => targetManufacturer.id === manufacturerId
      );
      targetManufacturer.isSelectable = targetManufacturer.models.some(
        model => model.isSelectable == true
      );
    },
    resetState(state) {
      for (let prop in state) {
        state[prop] = initialState[prop];
      }
    }
  }
};
